import { Switch } from "../ui/switch"

export function FilterSwitch({ isChecked, setIsChecked, disabled, label }) {

  const handleChange = (checked) => {
    setIsChecked(checked);
  };

  return (
    <div className="flex gap-3 items-center justify-between border border-input h-9 rounded-md text-sm px-3 py-2 text-muted-foreground">
      <p className="select-none">{label}</p>
      <Switch disabled={disabled} checked={isChecked} onCheckedChange={handleChange} />
    </div>
  )
}